import { EditIcon, PlusIcon } from "../../Icons";
import { Typo } from "../../Typo";

type CommentCellProps = {
  comment: string;
  onEdit: () => void;
};

// Non-empty comments show a brand-blue Edit icon, hidden until the row (a
// `group` in SubIBsTable's `getRowClassName`) is hovered — matches the
// confirmed design's `.comment-cell__edit` (display:none → row-hover reveal).
export const CommentCell = ({ comment, onEdit }: CommentCellProps) => {
  const empty = !comment;
  return (
    <button
      type="button"
      onClick={onEdit}
      aria-label={empty ? "Add comment" : "Edit comment"}
      className="flex w-full max-w-full items-center gap-2 text-left"
    >
      {empty && (
        <PlusIcon
          className="h-4 w-4 shrink-0 text-text-tertiary"
          aria-hidden="true"
        />
      )}
      <Typo
        element="span"
        type="bodySM"
        textColor={empty ? "text-text-tertiary" : "text-text-primary"}
        className="min-w-0 flex-1 truncate"
      >
        {empty ? "Add comments" : comment}
      </Typo>
      {!empty && (
        <span className="hidden h-6 w-6 shrink-0 items-center justify-center rounded-md transition-colors hover:bg-overlay-opacity-state-selected group-hover:inline-flex">
          <EditIcon
            className="h-4 w-4 text-icon-brand-default"
            aria-hidden="true"
          />
        </span>
      )}
    </button>
  );
};
